import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {
  STAGE_RUN_FULL_SHAPE,
  STAGE_RUN_SAMPLE_FULL_SHAPE,
  StageRun,
  StageRunSample,
} from 'workflows/WorkflowConstants';

import SelectParentStageRunSampleCell from './SelectParentStageRunSampleCell';
import SharedInputTableRow from './SharedInputTableRow';

interface PendingInputTableRowProps {
  checkboxCell: JSX.Element;
  experimentalConditionValueNames: Array<string>;
  stageRun: StageRun;
  pendingParentStageRuns: Array<StageRun>;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
  locked: boolean;
}

interface State {
  isSampleDropdownOpen: boolean;
}

/**
 * Input table row acting as a placeholder indicating that a parent has not sent any outputs to this
 * stage run. If outputs are available, the user can choose one in a dropdown.
 *
 * In the case that there are multiple unfulfilled parents, the dropdown allows selection from any of the
 * outputs.
 */
class PendingInputTableRow extends React.Component<PendingInputTableRowProps, State> {
  static propTypes = {
    checkboxCell: PropTypes.node.isRequired,
    experimentalConditionValueNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    stageRun: STAGE_RUN_FULL_SHAPE.isRequired,
    pendingParentStageRuns: PropTypes.arrayOf(STAGE_RUN_FULL_SHAPE.isRequired).isRequired,
    stageRunSampleById: PropTypes.objectOf(STAGE_RUN_SAMPLE_FULL_SHAPE).isRequired,
    locked: PropTypes.bool.isRequired,
  };

  state: State = {
    isSampleDropdownOpen: false,
  };

  _handleOpenSampleDropdown = (): void => {
    this.setState({isSampleDropdownOpen: true});
  };

  _handleCloseSampleDropdown = (): void => {
    this.setState({isSampleDropdownOpen: false});
  };

  _renderSampleCell(): JSX.Element {
    return (
      <SelectParentStageRunSampleCell
        stageRun={this.props.stageRun}
        // eslint-disable-next-line no-restricted-syntax
        eligibleParentStageRunIds={_.pluck(this.props.pendingParentStageRuns, 'id')}
        stageRunSampleById={this.props.stageRunSampleById}
        locked={this.props.locked}
        isDropdownOpen={this.state.isSampleDropdownOpen}
        onOpenDropdown={this._handleOpenSampleDropdown}
        onCloseDropdown={this._handleCloseSampleDropdown}
      >
        <div className="workflowDetailsTable-missingCellValue">Pending</div>
      </SelectParentStageRunSampleCell>
    );
  }

  _renderContainerCell(): JSX.Element {
    return <span />;
  }

  render(): JSX.Element {
    return (
      <SharedInputTableRow
        checkboxCell={this.props.checkboxCell}
        experimentalConditionValueNames={this.props.experimentalConditionValueNames}
        sampleCellFullElement={this._renderSampleCell()}
        containerCellContents={this._renderContainerCell()}
        stageRun={this.props.stageRun}
      />
    );
  }
}

export default PendingInputTableRow;
